import TUCard from './TUCard';

export default TUCard;
